import {
    Card, CardContent, TextField, Button, makeStyles, FormControl, Snackbar, RadioGroup, FormControlLabel, Radio, CircularProgress
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { getRoles } from '../auth-provider/ra-auth-jwt';
import qs from 'qs'

interface authTokenGroupBy {
    [key: string]: Array<authToken>
}

interface authToken {
    createdAt: string,
    expirationDate: string,
    gateway: string,
    id: string,
    isEnabled: boolean,
    token: string,
    updatedAt: string
}

var gateway: any = {
    PAYPING: "پی‌پینگ",
    VANDAR: "وندار",
    SNAPP_PAY: "اسنپ‌پی",
    ZEENAJI_PAYPING: "زیناجی پی‌پینگ",
    LIMOOME_ZIFY: "زیفای"
}

const useStyles = makeStyles((theme) => ({
    cancelBtn: {
        backgroundColor: 'rgb(220, 0, 78)',
        width: '20%',
        '&:hover': {
            backgroundColor: 'rgb(220, 0, 78)'
        }
    }
}));

async function getTokens() {
    let token: any = localStorage.getItem('credentials')
    const filters = {
        where: {
            gateway: {
                in: ["PAYPING", "VANDAR", "LIMOOME_ZIFY"]
            }
        }
    }
    const strigifiedFilters = qs.stringify(filters)
    return await axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens?${strigifiedFilters}`,
        // url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens?where%5Bgateway%5D[in]=PAYPING&where%5Bgateway%5D[in]=VANDAR`,
        method: 'GET'
    })
}

export function UpdatePaymentGatewayManager() {
    const classes = useStyles();
    const [authTokensGroupBy, setAuthTokenGroupBy] = useState<authTokenGroupBy>({});
    const [sendDataToServer, setSendDataToServer] = useState<Array<any>>([])
    // const [originalAuthToken, setOriginalAuthToken] = useState<Array<any>>([]);
    const [serverState, setServerState] = useState({
        status: 'NONE',
        message: '',
    })
    const [submitState, setSubmitState] = useState({
        status: 'NONE',
        message: '',
    })

    const getValue = (getway: string) => {
        let selectedAuthToken = authTokensGroupBy[getway].find((authToken: any) => authToken.isEnabled === true)
        return selectedAuthToken?.token ? selectedAuthToken.token : '';
    }

    const changeSelectedValue = (getway: string, authTokenId: string, e: any) => {
        let newAuthTokenGroupBy = authTokensGroupBy[getway].map((authToken: any) => {
            if (authToken.id === authTokenId) {
                let isExist = sendDataToServer.some((t: any) => t.gateway === getway)
                if (!isExist) {
                    let data = { gateway: getway, id: authToken.id }
                    setSendDataToServer([...sendDataToServer, { ...data }])
                }
                else {
                    let data = sendDataToServer.map((d) => {
                        if (d.gateway === getway)
                            return { ...d, id: authToken.id }
                        else
                            return d
                    })
                    setSendDataToServer(data)
                }
                //setSendDataToServer()
                return { ...authToken, isEnabled: true }
            }
            return { ...authToken, isEnabled: false }
        })
        setAuthTokenGroupBy({ ...authTokensGroupBy, [getway]: newAuthTokenGroupBy })
    }

    // const getDiff = () => {
    //     let originalAuthTokenGroupBy = convertOriginalToGroupBy(originalAuthToken)
    //     let diff: Array<any> = []
    //     Object.keys(originalAuthTokenGroupBy).forEach((gateway: string) => {
    //         originalAuthTokenGroupBy[gateway].forEach((oldAuthToken: authToken) => {
    //             let newAuthTokenGroupBy = authTokensGroupBy[gateway].find((newAuthToken: authToken) => newAuthToken.id === oldAuthToken.id)
    //             if (oldAuthToken.isEnabled !== newAuthTokenGroupBy?.isEnabled)
    //                 diff.push(newAuthTokenGroupBy);

    //         });
    //     })
    //     console.log('diff: ', diff);
    //     return diff
    // }

    const submit = async () => {

        setSubmitState({ status: "NONE", message: "" })
        // let authTokensDiff: Array<authToken> = getDiff()

        let promises: Array<any> = []

        sendDataToServer.forEach((sendData: any) => {
            promises.push(prepareUpdateRequest(sendData))
        });


        Promise.all(promises)
            .then(res => {
                setSubmitState({ status: "SUCCESSFUL", message: "تغییرات با موفقیت انجام شد." })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-successful')
            })
            .catch(e => {
                setSubmitState({ status: "ERROR", message: "خطا در ثبت" })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
            })
            .finally(() => {
                setSendDataToServer([])
            })

    }

    // const updateOriginalAuthToken = (authTokensDiff: Array<authToken>) => {
    //     let newOriginalAuthToken: Array<authToken> = originalAuthToken.map((oat: authToken) => {
    //         let isChange: authToken | undefined = authTokensDiff.find(atd => atd.id === oat.id)
    //         if (isChange)
    //             return { ...oat, isEnabled: !oat.isEnabled }
    //         else
    //             return oat
    //     })
    //     setOriginalAuthToken(newOriginalAuthToken)
    // }

    const prepareUpdateRequest = async (request: any) => {
        console.log('prepareUpdateRequest: ', request);
        let token: any = localStorage.getItem('credentials')
        await axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens/active-token`,
            data: { activeTokenId: request.id },
            method: 'PATCH'
        })
    }

    const convertOriginalToGroupBy = (tokens: Array<any>) => {
        let tokensGroupBy = tokens.reduce((group, cp) => {
            const { gateway } = cp;
            group[gateway] = group[gateway] ?? [];
            group[gateway].push(cp);
            return group;
        }, {});
        return tokensGroupBy;
    }

    const getGatewayNameFa = (gatewayName: string) => {
        return gateway[gatewayName]
    }

    const showContent = () => {
        switch (serverState.status) {
            case "SUCCESSFULL":
                return (
                    Object.keys(authTokensGroupBy).map((getwayName: string) => {
                        return (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }} key={getwayName}>
                                <p style={{ marginTop: '2rem', marginBottom: '0px', fontFamily: 'IranSans-Bold' }} key={getwayName}>{getGatewayNameFa(getwayName)}</p>
                                <hr style={{ height: '1px', border: '0', borderTop: '1px solid #ccc' }}></hr>
                                {
                                    authTokensGroupBy[getwayName].sort(sortAuthToken).map((authToken: any) => {
                                        return (
                                            <FormControl key={authToken.id} component="fieldset">
                                                <RadioGroup style={{ gap: '0.25rem' }} value={getValue(getwayName)} onChange={(e: any) => changeSelectedValue(getwayName, authToken.id, e)}>
                                                    <FormControlLabel style={{ flexDirection: 'row', fontFamily: 'IranSans-Thin' }} value={authToken.token} control={<Radio />} label={authToken.token.substring(authToken.token.length - 20, authToken.token.length)} />
                                                </RadioGroup>
                                            </FormControl>
                                        )
                                    })
                                }
                            </div>
                        )
                    })
                )
            case "PENDING":
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                        <CircularProgress />
                    </div>
                )
            case "ERROR":
                return (
                    <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem', color: 'red' }}>خطا در دریافت لیست توکن‌ها</p>
                )
            default:
                break;
        }
    }

    const sortAuthToken = (a: any, b: any) => {
        if (a.createdAt < b.createdAt) {
            return 1;
        }
        if (a.createdAt > b.createdAt) {
            return -1;
        }
        return 0;
    }

    useEffect(() => {
        setServerState({ status: "PENDING", message: "" })
        getTokens().then((res: any) => {
            // setOriginalAuthToken(res.data)
            console.log('use effect res.data: ', res.data)
            let result = convertOriginalToGroupBy(res.data);
            setAuthTokenGroupBy(result);
            console.log('setAuthTokenGroupBy: ', result)

            setServerState({ status: "SUCCESSFULL", message: "" })
        }).catch((e: any) => {
            setServerState({ status: "ERROR", message: "" })
        })
        let roles = getRoles();
        let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.payment_manager`)
        // let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.admin`)
        if (!isPaymentManager)
            window.location.href = '/'
    }, [])

    return (
        <Card>
            <CardContent>
                {/* <p>{JSON.stringify(sendDataToServer)}</p> */}
                <div className="dashboard-card" onClick={() => window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/payment-gateway-manager/create`}>
                    <p style={{ fontFamily: 'IranSans-Bold' }}>ایجاد توکن</p>
                </div>
                {showContent()}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submit()} style={{ color: '#fff' }} variant="contained" color="primary">ثبت</Button>
                </div>
                <Snackbar
                    open={submitState.status === 'ERROR' || submitState.status === 'SUCCESSFUL' ? true : false}
                    onClose={() => {
                        setSubmitState({ ...submitState, status: 'NONE' })
                    }}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    message={submitState.message}
                    style={{ backgroundColor: 'transparent', borderRadius: '12px' }}
                />
            </CardContent>
        </Card >
    )
}